'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { pageview } from '@/lib/gtag';

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const isProd = process.env.NODE_ENV === 'production';

const GoogleAnalytics = () => {
  const pathname = usePathname();

  // Track page views on route change
  useEffect(() => {
    if (!isProd || !GA_ID) return;
    pageview(pathname);
  }, [pathname]);

  // ⛔ Do not render anything outside production
  if (!isProd || !GA_ID) {
    return null;
  }

  return (
    <>
      {/* Load GA script */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />

      {/* Initialize GA */}
      <Script id="ga-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${GA_ID}', {
            anonymize_ip: true
          });
        `}
      </Script>
    </>
  );
};

export default GoogleAnalytics;
